// use common.js, so we can consume the config modules in the build flow
module.exports = Object.freeze({
  appName: 'lp-le-ihub',
  appCode: 'ihu',
});
